import React, {Component} from 'react';

class PopupParking extends Component {
    constructor(props) {
        super(props)
        this.handlePopupParking = this.handlePopupParking.bind(this);
    }

    handlePopupParking() {
        this.props.inactivePopupParking(false)
    }

    render() {
        return (
            <div id="popup-hair" className="slickModal isActive"
                 style={{"transition-duration": "0.4s"}}>
                <div className="slickOverlay closeModal setSlickCookie"
                     style={{'background': 'rgba(0, 0, 0, 0.85098)', 'transition-duration': '0.4s'}}></div>
                <div className="slickWindow center animated" style={{
                    'text-align': 'center',
                    'width': '337',
                    'height': '315px',
                    'box-shadow': 'rgba(0, 0, 0, 0.4) 0px 0px 20px 0px',
                    'background': 'rgb(255, 255, 255)',
                    'border-radius': '0px',
                    'margin': 'auto',
                    'padding': '0px',
                    'animation-duration': '0.4s',
                    'animation-delay': '0.2'
                }}>
                    <div className="slickCloseBtn close closeModal icon"
                         onClick={this.handlePopupParking}
                    ></div>
                    <div className="wrap">
                        <div className="popup-icon"></div>
                        <h2>Parking Policy</h2>
                        <div className="stylulist">
                            <strong>
                                <p>&nbsp;</p>
                                <p>Stylu Beauty Professionals will do their best to find free parking.
                                   If they are unable to, they reserve the right to charge you for
                                   parking above $5 and will charge the fee to your final receipt.
                                   Please see our FAQs for details.
                                </p>
                            </strong>
                        </div>
                    </div>
                    <div className="cta" style={{'display': 'none'}}>
                        <span className="closeModal">Close me</span>
                    </div>
                </div>
            </div>
        )
    }
}

export default PopupParking;



/** WEBPACK FOOTER **
 ** ./src/components/PopupParking.js
 **/